<template>
    <v-container fluid>
        <v-alert v-if="isNotLoggedIn" type="info"
            ><a href="/login?redirect=%2Fereader" style="color: white"
                >Log in</a
            >
            to CFMA to get your most recent eBook purchases.</v-alert
        >
    </v-container>
</template>

<script>
export default {
    name: "MessageBar",
    computed: {
        isNotLoggedIn: function() {
            return this.$store.state.notLoggedIn;
        }
    }
};
</script>
